// extracted by mini-css-extract-plugin
module.exports = {"riskStatement":"index_riskStatement_36hZI","slogan":"index_slogan_PyCKI","statement":"index_statement_6nOjH"};